import { useEffect, useState } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import ButtonSubmitCancel from '../general/ButtonSubmitCancel.jsx';
import FieldWrapperWithoutLabel from './FieldWrapperWithoutLabel.jsx';
import AddNewSectionTypes from './fields/AddNewSection/AddNewSectionTypes.jsx';
import AddNewSectionTypesOption from './fields/AddNewSection/AddNewSectionTypesOption.jsx';
import * as Yup from 'yup';
import Translation from '../Translation/cont/Translation.jsx';
import config from '../../config.json'
import RadioButtonGroup from './fields/RadioButtonGroup.jsx';
import RadioButtonWrapper from './fields/RadioButtonWrapper.jsx';
import sortCinemas from '../../functions/sortCinemas.jsx';
import { sanitizeFormInput, sanitizeFormOutput } from '../../functions/formFunctions.js';
import { SELECTION_ELEMENT_DEFAULT } from '../../constants/state.js';
import MultiselectCheckboxCinemas from './fields/MultiselectCheckboxCinemas.jsx';
import FieldWrapper from './FieldWrapper.jsx';
import addFormikData from '../../functions/addFormikData.js';
import positionConfig from '../../attribute-position-config.json'
import RadioButton from './fields/SingleSelectRadiobutton.jsx';

const AddNewSectionObserver = ({type, setEditSelectionSettings, setEditSelectionAutoplay, setFieldValue}) => {
    useEffect(() => {
        if('slider' === type || 'highlight' === type || 'stripe' === type) {
            setEditSelectionSettings(true)
            setEditSelectionAutoplay(true)
        } else {
            setEditSelectionSettings(false)
            setEditSelectionAutoplay(false)
            setFieldValue('style', "Classic")
            setFieldValue('trailerAutoplay', "false")
        }
    }, [type])
  
    return null
}
    
const AddNewSection = ({ sectionEnterTitleString, selectionActiveClass, allGenres, collapseActiveSelection, cliCinemas, clientCinemaId, addDisplaySelection, technicalAttributes, features, hasShowtimes, hasAdvertisements}) => {
    const [editSelectionSettings, setEditSelectionSettings] = useState(false) 
    const [editSelectionAutoplay, setEditSelectionAutoplay] = useState(false)

    const handleCancel = (reset) => {
        reset()
        collapseActiveSelection(selectionActiveClass)
    }

    const getValues = arr => {
        return arr.map(item => item.id)
    }
    const {destinationType, pathType} = positionConfig
    const newLinkData = {
        destinationType: "internal",
        pathType: "absolute",
        url: "",
        text: ""
    }
    const sectionSettings = config.sectionSettings
    const styleOptions = sectionSettings.styleTypes.filter(option => !option.id.includes('Poster') && !option.id.includes('InformationLoop'))
    const stripeStyleOptions = sectionSettings.stripeStyleTypes
    const allStyleOptions = _.union(styleOptions, stripeStyleOptions)
    const autoplayTypes = sectionSettings.autoplayTypes
    const cliCinemasIdList = sortCinemas(clientCinemaId, cliCinemas)
    const cinemaDomain = cliCinemas[clientCinemaId].website
    
    let initValues = SELECTION_ELEMENT_DEFAULT
    if(initValues && initValues.cinemasFilter === null) {
        initValues.cinemasFilter = cliCinemasIdList
    }
    
    const validationSchema = Yup.object().shape({
        title: Yup.string().required(<Translation id="formik_field_required" />),
        type: Yup.string().required(<Translation id="formik_field_required" />),
        // ToDo: rest
        showInApp: Yup.boolean().required(<Translation id="formik_field_required" />),
        style: Yup.string().oneOf(getValues(allStyleOptions)).required(),
        trailerAutoplay: Yup.string().oneOf(getValues(sectionSettings.autoplayTypes)).required()
    })

    return (
        <Formik 
            initialValues={addFormikData(sanitizeFormInput(initValues), newLinkData, "link")}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
                values.trailerAutoplay = "true" === values.trailerAutoplay
                addDisplaySelection(sanitizeFormOutput(values))
                actions.resetForm()
                actions.setSubmitting(false)
            }}>
            {({values, errors, touched, isSubmitting, handleReset, setFieldValue}) => 
                <Form>
                    <div className={"add-section section-end selections-item header-" + selectionActiveClass}>
                        <h3 className="cursor-pointer selections-item-title accordion-header site-content-wrapper-inner title-large-color" onClick={() => handleCancel(handleReset)}>
                            <span><Translation id="section_add_item" /></span>
                        </h3>
                        <div className={'selections-item-content accordion-item ' + selectionActiveClass}>
                            <div className="section-left">
                                <div>
                                    <FieldWrapperWithoutLabel>
                                        <Field placeholder={sectionEnterTitleString} type="text" name="title" id="section-title" className="input-field text-light" />
                                    </FieldWrapperWithoutLabel>
                                    <ErrorMessage className="text-regular-color" name="title" component="div" />  
                                </div>

                                <div>
                                    <AddNewSectionTypes 
                                        hasShowtimes={hasShowtimes} 
                                        hasAdvertisements={hasAdvertisements} 
                                        setFieldValue={setFieldValue}
                                    />
                                </div>
                                <div>

                                    {editSelectionSettings && <RadioButtonGroup
                                        label={<Translation id="selection_style_choose_label"/>}
                                        description={<Translation id={"selection_style_description_" + values.type}/>}
                                        className="select-new-style-type"
                                    >
                                        <ErrorMessage className="text-regular-color movie-error" name="style" component="div" /> 

                                        {values.type === "stripe" ? stripeStyleOptions.map(({transId, id}) => (
                                            <RadioButtonWrapper 
                                                key={id} 
                                                id={id} 
                                                label={<Translation id={transId}/>}
                                            >
                                                <Field
                                                    id={id}
                                                    type="radio"
                                                    name="style"
                                                    value={id}
                                                />

                                            </RadioButtonWrapper>
                                        )) : styleOptions.map(({transId, id}) => (
                                            <RadioButtonWrapper 
                                                key={id} 
                                                id={id} 
                                                label={<Translation id={transId}/>}
                                            >
                                                <Field
                                                    id={id}
                                                    type="radio"
                                                    name="style"
                                                    value={id}
                                                />

                                            </RadioButtonWrapper>
                                        ))}
                                    </RadioButtonGroup>}
                                    {values.style === "CustomButton" && <div className='field-text'>
                                        <FieldWrapper label={<Translation id="content_link_text"/>} id="content-link-text" classes="field-text">
                                            <Field type="text" name="link.text" id="content-link-text" className="text-regular input-text-box" />
                                            <ErrorMessage name="link.text" component="div" /> 
                                        </FieldWrapper>

                                        <FieldWrapper label={<Translation id="content_link_url"/>} id="content-link-url" classes="field-text">
                                            <Field type="text" name="link.url" id="content-link-url" className="text-regular input-text-box" />
                                            <ErrorMessage name="link.url" component="div" /> 
                                        </FieldWrapper>
                                        <RadioButtonGroup
                                            label={<Translation id="content_link_target"/>}
                                            description={<Translation id="content_link_target_info"/>}
                                            className="select-new-section-type field-text"
                                        >
                                            <ErrorMessage className="text-regular-color movie-error" name="link.destinationType" component="div" /> 
                                            {destinationType.map(type => {
                                                const {transId, id} = type
                                                return (
                                                    <Field
                                                        key={id}
                                                        component={RadioButton}
                                                        name="link.destinationType"
                                                        id={id}
                                                        label={<Translation id={transId}/>}
                                                    />
                                                )
                                            })}
                                        </RadioButtonGroup>
                                        <RadioButtonGroup
                                            label={<Translation id="content_link_type"/>}
                                            description={<Translation id="content_link_type_info" after={' ' + cinemaDomain}/>}
                                            className="select-new-section-type field-text"
                                        >
                                            <ErrorMessage className="text-regular-color movie-error" name="link.pathType" component="div" /> 
                                            {pathType.map(type => {
                                                const {transId, id} = type
                                                return (
                                                    <Field
                                                        key={id}
                                                        component={RadioButton}
                                                        name="link.pathType"
                                                        id={id}
                                                        label={<Translation id={transId}/>}
                                                    />
                                                )
                                            })}
                                        </RadioButtonGroup>
                                    </div>}
                                </div>

                                <div>
                                    {editSelectionAutoplay && features.has_trailer_views && values.type !== 'stripe' && <RadioButtonGroup
                                        label={<Translation id="selection_trailer_autoplay_label"/>}
                                        description=""
                                        className="select-new-section-type"
                                    >
                                        <ErrorMessage className="text-regular-color movie-error" name="trailerAutoplay" component="div" /> 

                                        {autoplayTypes.map(({transId, id}) => (
                                            <RadioButtonWrapper
                                                key={id} 
                                                id={id} 
                                                label={<Translation id={transId}/>}
                                            >
                                                <Field
                                                    id={id}
                                                    type="radio"
                                                    name="trailerAutoplay"
                                                    value={id}
                                                />
                                            </RadioButtonWrapper>

                                        ))}
                                    </RadioButtonGroup>}
                                </div>
                                {_.has(values, "cinema") && cliCinemas ? (
                                    cliCinemasIdList.length > 1 ? (
                                        <fieldset className="field-cinemas">
                                                <legend className="field-text-label"><Translation id="content_cinemas"/></legend>                                                
                                                <div className="select-all-cinemas-button-wrapper">  
                                                    <div key={'field-all'} className="field-checkbox">
                                                        <Field 
                                                            key={'all'} 
                                                            attrid={'all'}
                                                            name="cinemas"
                                                            component={MultiselectCheckboxCinemas} 
                                                            id={'alle anwählen'}
                                                            clicinemas={'all'}
                                                            value={cliCinemasIdList} 
                                                        />
                                                    </div>
                                                </div>

                                                <div className="grid-container">
                                                    {cliCinemasIdList.map(cinemaId => {
                                                        const cinema = cliCinemas[cinemaId]
                                                        const {pk, nameShort} = cinema

                                                        return (
                                                            <div key={'field' + pk} className="field-checkbox">
                                                                <Field 
                                                                    key={pk} 
                                                                    attrid={pk}
                                                                    name="cinemas"
                                                                    component={MultiselectCheckboxCinemas} 
                                                                    id={nameShort}
                                                                    clicinemas={cliCinemas}
                                                                    value={pk}
                                                                />
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </fieldset>
                                        ) : (
                                            cliCinemasIdList.map(cinemaId => {
                                                const cinema = cliCinemas[cinemaId]
                                                const {pk, nameShort} = cinema
                                                
                                                return (
                                                    <div key={'field' + pk} className="field-checkbox">
                                                        <Field 
                                                            key={pk} 
                                                            attrid={pk}
                                                            name="cinemas"
                                                            component={MultiselectCheckboxCinemas} 
                                                            id={nameShort}
                                                            clicinemas={cliCinemas}
                                                            value={pk} 
                                                        />
                                                    </div>
                                                )
                                            })
                                        )
                                    ) : (
                                        ''
                                    )
                                }

                                {features && features.has_mcs_app && <div className="field-checkbox">
                                    <label>
                                        <Field type="checkbox" name="showInApp" id="show-in-app" className="checkbox"/>
                                        <span className="show-in-app-text text-regular"><Translation id="app_display"/></span>
                                    </label>
                                    <ErrorMessage className="text-regular-color" name="showInApp" component="div" />  
                                </div>}
                            </div>

                            <div className="section-right">
                                <AddNewSectionTypesOption 
                                    allGenres={allGenres} 
                                    technicalAttributes={technicalAttributes} 
                                    values={values} 
                                    errors={errors} 
                                    touched={touched}
                                />

                                <ButtonSubmitCancel
                                    wrapperClassName="add-selection-buttons"
                                    transIdCancel="cancel_button"
                                    transIdSubmit="add_button"
                                    disabledCancel={isSubmitting}
                                    disabledSubmit={isSubmitting}
                                    onCancel={() => handleCancel(handleReset)}
                                />
                            </div>
                        </div>
                    </div>

                    <AddNewSectionObserver 
                        type={values.type}
                        setEditSelectionSettings={setEditSelectionSettings}
                        setEditSelectionAutoplay={setEditSelectionAutoplay}
                        setFieldValue={setFieldValue}
                    />
                </Form>
            }
        </Formik>
    )
}

export default AddNewSection